<template>
    <div class="qualification-view">
        <h1>企业资质</h1>
        <!-- 资质证书将在这里展示 -->
    </div>
</template>

<script>
export default {
    name: 'QualificationView',
};
</script>

<style scoped>
.qualification-view {
    padding: 32px;
}
</style>